import _get from 'lodash/get'
import _size from 'lodash/size'
import { post as apiPost, TYPE_BROOKLYN_JSON } from 'api-client'
import { getAuthIsLoggedIn } from 'services/auth'
import {
  isAccountPage,
  isCheckoutFlowPage,
  isGiftPaymentPage,
  isSinglePageCheckout,
} from 'services/url'

export const VELOCITY_CHECK_DOMAIN = 'Gaia'
export const VELOCTIY_CHECK_ACTION_AREA_UNKNOWN = 'unknown'
export const VELOCTIY_CHECK_ACTION_AREA_CHECKOUT = 'checkout'
export const VELOCTIY_CHECK_ACTION_AREA_REACTIVATION = 'reactivation'
export const VELOCTIY_CHECK_ACTION_AREA_UPDATE_PAYMENT = 'updatePayment'
export const VELOCTIY_CHECK_ACTION_AREA_GIFT = 'gift'

export function handleVelocityCheckResponse (res, _dataError) {
  const data = _get(res, 'body', {})
  const errors = _size(_get(res, ['body', 'errors'])) > 0
  return {
    _dataError: _dataError || errors || null,
    token: _get(data, 'token', null),
    success: _get(data, 'success', false),
  }
}

export function handleAuthorizationResponse (res, _dataError) {
  const data = _get(res, 'body', {})
  return {
    _dataError: _dataError || null,
    success: _get(data, 'success', false),
  }
}

/**
 * Brooklyn request to post data for the velocity check
 * @param {Object} [options={}] The options
 * @param {String} options.fingerprintId The visitor id generated by fingerprintJS
 * @param {String} options.userInfoUuid The user uuid for the logged in user
 */
export async function checkVelocity (options = {}) {
  const {
    fingerprintId,
    requestId,
    userInfoUuid,
    page,
    auth,
  } = options

  try {
    const res = await apiPost('v1/billing/check', {
      fingerprintId, requestId, userInfoUuid, page, domain: VELOCITY_CHECK_DOMAIN,
    }, { timeout: 10000, auth }, TYPE_BROOKLYN_JSON)
    return handleVelocityCheckResponse(res)
  } catch (e) {
    return handleVelocityCheckResponse({
      body: {
        success: false,
      },
    }, true)
  }
}

/**
 * Brooklyn request to post data for the velocity check
 * @param {Object} [options={}] The options
 * @param {String} options.fingerprintId The visitor id generated by fingerprintJS
 * @param {String} options.userInfoUuid The user uuid for the logged in user
 * @param {String} options.success Whether or not the CC paymement token succeeded or failed
 * @param {String} options.failureReason The reason or message for failure
 * @param {String} options.token The velocity token if one exists
 */
export async function setAuthorization (options = {}) {
  const {
    fingerprintId,
    userInfoUuid,
    success,
    failureReason,
    token,
    auth,
  } = options

  try {
    const res = await apiPost('v1/billing/authorization', {
      fingerprintId, userInfoUuid, success, failureReason, token,
    }, { auth }, TYPE_BROOKLYN_JSON)
    return handleAuthorizationResponse(res)
  } catch (e) {
    return handleAuthorizationResponse({
      body: {
        success: false,
      },
    }, true)
  }
}

export function getVelocityCheckActionLocation (options) {
  const { auth, checkout, resolver } = options
  let actionName = VELOCTIY_CHECK_ACTION_AREA_UNKNOWN
  const isLoggedIn = getAuthIsLoggedIn(auth.get('jwt'))
  const isReactivation = checkout.get('reactivation')
  const path = resolver.get('path')

  if (isReactivation && isCheckoutFlowPage(path)) {
    actionName = VELOCTIY_CHECK_ACTION_AREA_REACTIVATION
  } else if (!isReactivation && isCheckoutFlowPage(path)) {
    actionName = VELOCTIY_CHECK_ACTION_AREA_CHECKOUT
  } else if (isLoggedIn && isSinglePageCheckout(path)) {
    actionName = VELOCTIY_CHECK_ACTION_AREA_CHECKOUT
  } else if (isLoggedIn && isAccountPage(path)) {
    actionName = VELOCTIY_CHECK_ACTION_AREA_UPDATE_PAYMENT
  } else if (isLoggedIn && isGiftPaymentPage(path)) {
    actionName = VELOCTIY_CHECK_ACTION_AREA_GIFT
  }

  return actionName
}
